export function me(me) {
  return {
    type: "@me/me",
    payload: {
      me,
    },
  };
}
